import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { authFetch } from '../../../utils/api';

const GrillPatternSimple = ({ value, onChange, id = 'GrillPatternSimple', label = 'Grill Patterns', disabled = false, appliesTo = 'windows', showNone = true }) => {
    const defaultValue = value?.value || '';
    const [selectedPattern, setSelectedPattern] = useState(defaultValue);
    const [patterns, setPatterns] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch grill patterns simple from API
    useEffect(() => {
        authFetch(`/grills/patterns-simple?applies_to=${appliesTo}`)
            .then(data => {
                const activePatterns = data.filter(t => t.active);
                setPatterns(activePatterns);
                setLoading(false);
            })
            .catch(err => {
                console.error('Failed to fetch grill patterns simple:', err);
                setLoading(false);
            });
    }, []);

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedPattern(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when options are loaded
    useEffect(() => {
        if (!loading && !selectedPattern) {
            if (showNone) {
                setSelectedPattern('None');
                onChange({ value: 'None', label: 'None' });
            } else if (patterns.length > 0) {
                const defaultOption = patterns[0];
                const newValue = defaultOption?.value || '';
                const newLabel = defaultOption?.label || '';
                setSelectedPattern(newValue);
                onChange({ value: newValue, label: newLabel });
            }
        }
    }, [loading, patterns, showNone]);

    const handlePatternChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedPattern(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedPattern}
                onChange={handlePatternChange}
            >
                {loading ? (
                    <option value="">Loading...</option>
                ) : (
                    <>
                        {showNone && (
                            <option value="None">
                                {selectedPattern === 'None' ? 'None ✔' : 'None'}
                            </option>
                        )}
                        {patterns.map(option => (
                            <option key={option.id} value={option.value}>
                                {selectedPattern === option.value ? `${option.label} ✔` : option.label}
                            </option>
                        ))}
                    </>
                )}
            </select>
        </div>
    );
};

export default GrillPatternSimple;
